var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone"},[_c('vs-tooltip',{attrs:{"text":this.country_name,"color":"primary"}},[_c('country-flag',{staticClass:"phone-img",attrs:{"country":this.country_code,"size":"normal"}})],1),_c('span',{staticClass:"phone-number"},[_vm._v(_vm._s(this.phone))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }